{
    "webshop_offer_voucher_correctCode": "Annettu koodi on oikea",
    "webShop_howToFindId_desc": "Voit kopioida oman tunnuksesi pelaajaprofiilistasi.",
    "webShop_howToFindId_link": "Mistä löydän oman tunnukseni?",
    "webshop_offer_voucher_codeIsIncorrect": "Koodi on virheellinen",
    "webshop_offer_voucher_enterYourCode": "Syötä henkilökohtainen tunnuksesi",
    "webShop_unexpectedError_desc": "Tapahtui odottamaton virhe. Yritä myöhemmin uudelleen.",
    "webShop_accountBanned_desc": "Tili on käyttökiellossa!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Käyttöehdot",
    "webshop_purchase_privacyPolicy": "Tietosuojakäytäntö",
    "webshop_legal_1": "Juridiset tiedot",
    "webshop_support_1": "Tuki",
    "mbs_access_welcome_desc": "Tervetuloa, {0}",
    "btn_login": "Kirjaudu",
    "mbs_access_error_sessionExpired_desc": "Sessiosi on vanhentunut. Kirjoita tilitunnuksesi."
}
